import styled from 'styled-components';
const DashLine = () => {
  return <DashLineWrapper />;
};
const DashLineWrapper = styled.div`
  background-image: linear-gradient(to right, #4e6e29 33%, rgba(255, 255, 255, 0) 0%);
  background-position: bottom;
  background-size: 22px 3px;
  background-repeat: repeat-x;
  height: 3px;
  width: 100%;
`;

export default DashLine;
